/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { Ultrafiltro } from "./modelUltrafiltro";

class ControllerUltrafiltro extends ControllerModel {
  constructor() {
    super("ControllerUltrafiltro");
    
    this.setNewNode = (callback) => {
      let ultrafiltro = new Ultrafiltro();
      ultrafiltro.decorate(callback);

      this.addNode(ultrafiltro);
    }

    this.loadNode = (node, callback) => {
      let ultrafiltro = new Ultrafiltro();
      ultrafiltro.copyFrom(node);
      ultrafiltro.decorate(callback);
      this.addNode(ultrafiltro)
    }

    this.getProperties = async (node) => {
      let n = new Ultrafiltro();
      await n.copyFrom(node);
      return n.data
  }

  this.getNode = (node) => {
      let n = new Ultrafiltro();
      n.copyFrom(node);
      return n
  }
  }
}

export { ControllerUltrafiltro };
